import React from 'react';
import {render} from 'react-dom';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {Provider} from 'react-redux';
import Store from './store';
import Modal from 'components/molecules/modal-windows/modal';
import URL from 'url';
import App from './containers/app';
import NotFoundPage from 'desktop/pages/404';
import IndexPage from 'desktop/pages/index';

import 'font-awesome/css/font-awesome.css';
import './assets/styles/site.css';
import './assets/styles/styles-desktop.scss';

const theme = process.env.FRONTEND_THEME;

if (theme) {
    try {
        require(`./assets/styles/themes/${theme}-desktop.scss`);
    } catch (e) {
        console.error(e);
    }
}

render(
    <Provider store={Store}>
        <Router>
            <App>
                <Switch>
                    <Route path={URL.toHome()} component={IndexPage} />
                    <Route component={NotFoundPage} />
                </Switch>
            </App>
        </Router>
    </Provider>,
    document.getElementById('wrapper'),
);

render(
    <Provider store={Store}>
        <Modal />
    </Provider>,
    document.getElementById('modal'),
);
